import BaseEntity from '../base/BaseEntity.model';

export default class AcademicTitle extends BaseEntity{
    public name?: string | null;

    constructor(){
        super();
        this.init();
    }

    init(){
        this.name = null;
    }
}